import { Eye, HelpCircle, X } from "lucide-react";
import { useState } from "react";
import { useFormatAmount } from "../../hooks/useFormatAmount";

const MyChattels = ({ chattels, closeMyChattels }) => {
  const [expandedChattelId, setExpandedChattelId] = useState(null);
  const formatAmount = useFormatAmount();

  const toggleExpand = (id) => {
    setExpandedChattelId((prev) => (prev === id ? null : id));
  };
  return (
    <div
      onClick={(e) => {
        closeMyChattels();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[600px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeMyChattels}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="flex items-end justify-between">
          <div>
            <p className="text-[#000000] font-normal text-[14px]">
              View Chattels
            </p>
            <p className="text-[#000000] font-semibold text-[20px]">Chattels</p>
          </div>
        </div>

        {/* Header */}
        <div className="h-[40px] w-full bg-[#F3F3F3] mt-[20px] px-[10px] flex items-center">
          <div className="w-[15%] text-[#222222] font-normal text-[14px]">
            ID
          </div>
          <div className="w-[30%] text-[#222222] font-normal text-[14px]">
            NAME
          </div>
          <div className="w-[27%] text-[#222222] font-normal text-[14px]">
            CHATTEL LOCATION
          </div>
          <div className="w-[24%] truncate text-[#222222] font-normal text-[14px]">
            VIEW / DELETE
          </div>
        </div>

        {/* Rows */}
        {chattels?.length === 0 ? (
          <div className="h-[350px] flex flex-col items-center justify-center gap-[10px]">
            <HelpCircle />
            <p>No chattel information available</p>
          </div>
        ) : (
          chattels?.map((item) => (
            <div key={item?.id}>
              {/* Row */}
              <div className="h-[40px] w-full bg-white px-[10px] flex items-center">
                <div className="w-[15%] text-[#222222] text-[14px]">
                  {item?.public_id}
                </div>
                <div className="w-[30%] text-[#00A676] text-[14px]">
                  {item?.name}
                </div>
                <div className="w-[27%] text-[#222222] text-[14px]">
                  {item?.location}
                </div>
                <div className="w-[24%] flex gap-3 items-center">
                  <Eye
                    className="w-4 h-4 text-[#222222] cursor-pointer"
                    onClick={() => toggleExpand(item?.id)}
                  />
                </div>
              </div>

              {/* Expanded Details */}
              {expandedChattelId === item?.id && (
                <div className="bg-[#F9F9F9] flex flex-col gap-[5px] px-4 py-3 text-sm text-[#333]">
                  <p className="font-bold">Chattel details</p>
                  <p>
                    <span className="font-semibold">Name:</span>{" "}
                    {item?.name || "N/A"}
                  </p>
                  <p>
                    <span className="font-semibold">Value:</span>{" "}
                    {formatAmount(item?.value ?? 0) || "N/A"}
                  </p>
                  <p>
                    <span className="font-semibold">Description:</span>{" "}
                    {item?.description || "N/A"}
                  </p>
                  <p>
                    <span className="font-semibold">Location:</span>{" "}
                    {item?.location}
                  </p>
                  <p>
                    <span className="font-semibold">Condition:</span>{" "}
                    {item?.condition}
                  </p>
                  {/* Images */}
                  {item?.images?.length > 0 && (
                    <div className="mt-2">
                      <p className="font-semibold mb-2">Images</p>
                      <div className="flex gap-3 flex-wrap">
                        {item.images.map((img) => (
                          <div
                            key={img.id}
                            className="w-[120px] h-[120px] rounded-md overflow-hidden border border-gray-300"
                          >
                            <img
                              src={img.imageUrl}
                              alt={item?.name}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MyChattels;
